<template>
  <div class="container">
    <div class="titulo text-center">
      <h2><strong>REGISTRO DE USUARIOS</strong></h2>
    </div>

    <div class="d-flex justify-content-between mb-3">
      <button v-if="!isFormVisible" @click="showForm" class="btn btn-success">
        <i class="bi bi-person-fill-add"></i> Agregar nuevo usuario
      </button>
      <input
        v-model="searchQuery"
        type="text"
        class="form-control w-25"
        placeholder="Buscar"
      />
    </div>

    <div v-if="isLoading" class="text-center">
      <p>Cargando usuarios...</p>
    </div>

    <div v-else class="table-container">
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>ID Usuario</th>
            <th>Rol</th>
            <th>Nombre</th>
            <th>Usuario</th>
            <th>Correo</th>
            <th>Número de celular</th>
            <th>Estatus</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="usuario in paginatedUsuarios" :key="usuario.Id_usuario">
            <td>{{ usuario.Id_usuario }}</td>
            <td>{{ usuario.rol }}</td>
            <td>{{ usuario.nombre }}</td>
            <td>{{ usuario.usuario }}</td>
            <td>{{ usuario.correo }}</td>
            <td>{{ usuario.celular }}</td>
            <td>
              <span :class="usuario.estatus === 'Activo' ? 'badge bg-success' : 'badge bg-danger'">
                {{ usuario.estatus }}
              </span>
            </td>
            <td>
              <button @click="editUsuario(usuario)" class="btn btn-link">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button @click="deleteUsuario(usuario.Id_usuario)" class="btn btn-link1">
                <i class="bi bi-trash-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <nav aria-label="Page navigation example">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">Siguiente</button>
        </li>
      </ul>
    </nav>

    <div v-if="isFormVisible" class="form-container">
      <h3>{{ isEditing ? "Editar Usuario" : "Agregar Usuario" }}</h3>
      <form @submit.prevent="isEditing ? submitEditForm() : submitForm()">
        <div class="form-group">
          <label for="rol">Rol</label>
          <select v-model="usuario.rol" id="rol" class="form-control" required>
            <option value="empleado">Empleado</option>
            <option value="administrador">Administrador</option>
          </select>
        </div>
        <div class="form-group">
          <label for="nombre">Nombre</label>
          <input v-model="usuario.nombre" type="text" id="nombre" class="form-control" required />
        </div>
        <div class="form-group">
          <label for="usuario">Usuario</label>
          <input v-model="usuario.usuario" type="text" id="usuario" class="form-control" required />
        </div>
        <div class="form-group">
          <label for="correo">Correo</label>
          <input v-model="usuario.correo" type="email" id="correo" class="form-control" required />
        </div>
        <div class="form-group">
          <label for="celular">Número de celular</label>
          <input v-model="usuario.celular" type="tel" id="celular" class="form-control" required />
        </div>
        <div class="form-group">
          <label for="contrasena">Contraseña</label>
          <input v-model="usuario.contrasena" type="password" id="contrasena" class="form-control" :required="!isEditing" />
        </div>
        <div class="form-group">
          <label for="estatus">Estatus</label>
          <select v-model="usuario.estatus" id="estatus" class="form-control">
            <option value="Activo">Activo</option>
            <option value="Inactivo">Inactivo</option>
          </select>
        </div>
        <button type="submit" class="btn btn-primary me-2">{{ isEditing ? "Actualizar" : "Guardar" }}</button>
        <button type="button" class="btn btn-secondary" @click="cancelForm">Cancelar</button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2"; // Importa SweetAlert2

export default {
  data() {
    return {
      usuarios: [],
      usuario: {
        Id_usuario: null,
        rol: "",
        nombre: "",
        usuario: "",
        correo: "",
        celular: "",
        contrasena: "",
        estatus: "Activo",
      },
      isFormVisible: false,
      isEditing: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 10,
      isLoading: false,
    };
  },
  computed: {
    filteredUsuarios() {
      if (!Array.isArray(this.usuarios)) {
        return [];
      }
      return this.usuarios.filter((usuario) =>
        `${usuario.nombre} ${usuario.usuario} ${usuario.rol}`
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedUsuarios() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredUsuarios.slice(startIndex, startIndex + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredUsuarios.length / this.itemsPerPage);
    },
  },
  methods: {
    fetchUsuarios() {
      this.isLoading = true;
      axios
        .get(this.$backendUrl+ "/index.php/usuarios/lista_completa")
        .then((response) => {
          if (Array.isArray(response.data)) {
            this.usuarios = response.data;
          } else {
            Swal.fire("Error", "La respuesta del servidor no es válida.", "error");
            this.usuarios = [];
          }
        })
        .catch((error) => {
          console.error("Error al obtener usuarios:", error);
          Swal.fire("Error", "No se pudo conectar al servidor.", "error");
          this.usuarios = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submitForm() {
      axios
        .post(this.$backendUrl+ "/index.php/usuarios/insertar", this.usuario)
        .then(() => {
          this.fetchUsuarios();
          this.cancelForm();
          Swal.fire("Éxito", "Usuario agregado correctamente.", "success");
        })
        .catch((error) => {
          console.error("Error al agregar usuario:", error);
          Swal.fire("Error", "Hubo un problema al agregar el usuario.", "error");
        });
    },
    submitEditForm() {
      axios
        .post(this.$backendUrl+ "/index.php/usuarios/actualizar", this.usuario)
        .then(() => {
          this.fetchUsuarios();
          this.cancelForm();
          Swal.fire("Éxito", "Usuario actualizado correctamente.", "success");
        })
        .catch((error) => {
          console.error("Error al actualizar usuario:", error);
          Swal.fire("Error", "No se pudo actualizar el usuario.", "error");
        });
    },
    deleteUsuario(id) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.$backendUrl+ "/index.php/usuarios/borrar", {
              data: { Id_usuario: id },
            })
            .then(() => {
              this.fetchUsuarios();
              Swal.fire("Eliminado", "El usuario ha sido eliminado.", "success");
            })
            .catch((error) => {
              console.error("Error al eliminar usuario:", error);
              Swal.fire("Error", "No se pudo eliminar el usuario.", "error");
            });
        }
      });
    },
    showForm() {
      this.isFormVisible = true;
      this.isEditing = false;
      this.resetForm();
    },
    editUsuario(usuario) {
      this.isFormVisible = true;
      this.isEditing = true;
      this.usuario = { ...usuario };
    },
    cancelForm() {
      this.isFormVisible = false;
      this.resetForm();
    },
    resetForm() {
      this.usuario = {
        Id_usuario: null,
        rol: "",
        nombre: "",
        usuario: "",
        correo: "",
        celular: "",
        contrasena: "",
        estatus: "Activo",
      };
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
  mounted() {
    this.fetchUsuarios();
  },
};
</script>




<style scoped>
.table-container {
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  margin-top: 20px;
}

.pagination .page-link {
  cursor: pointer;
}

.titulo {
  background-color: #f52349; /* Fondo rosa */
  color: white;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 15px;
  padding: 15px 10px;
  margin: 5px 0 10px 0; /* Espacio superior e inferior */
}

.btn-link {
  color: #2fc1f6; /* Color de enlace */
  background-color: transparent;
  font-size: 150%;
  border: none;
  padding-right: 10px;
  align-content: center;
}

.btn-link:hover {
  color: #ce13a2; /* Color al pasar el mouse */
}

.btn-link1 {
  color: red; /* Color de enlace */
  background-color: transparent;
  font-size: 150%;
  border: none;
  padding-left: 10px;
}
</style>
